module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metabase/code/metabase-org/releases/release-2023-03-28/metabase-0.46.0/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metabase/code/metabase-org/releases/release-2023-03-28/metabase-0.46.0/node_modules/source-map-loader/dist/cjs.js!/Users/metabase/code/metabase-org/releases/release-2023-03-28/metabase-0.46.0/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}